import React from 'react';
import {
    Create,
    required,
    //ReferenceField,
    SimpleForm,
    TextField
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { parse } from 'query-string';

const PostCreate = (props) => {

    const { thread: thread_iri, parent: parent_iri, user: user_iri } = parse(props.location.search);

    const thread = thread_iri;

    const parent = parent_iri;

    const user = user_iri;

    const redirect = ''; //thread && parent && user ? `/threads/${thread}/show/posts` : '';

    return (
        <Create {...props}>
            <SimpleForm
                defaultValue={{ thread, parent, user }}
                redirect={redirect}
            >
                <TextField label="Thread" source="thread" />
                <TextField label="Parent" source="parent" />
                <TextField label="User" source="user" />
                <RichTextInput label="Message" validate={ required() } source="message" />
            </SimpleForm>
        </Create>
    );
};

export default PostCreate;
